<template>
  <el-table-column align="center" :label="label" :fixed="fixed" :prop="prop" :width="width">
    <template v-if="!col.child || !col.child.length" #default="{ row, column }">
      <EditableText
        :editable="editable"
        :type="type"
        :target="pre ? row[pre] : row"
        :prop="column.property"
      />
    </template>
    <CustomColumn
      v-for="item in col.child || []"
      :key="col.code + item.prop"
      :col="item"
      :pre="prop"
    />
  </el-table-column>
</template>

<script>
import EditableText from './editable-text.vue';

export default {
  name: 'CustomColumn',
  components: {
    EditableText
  },
  props: {
    col: {
      type: Object,
      default: () => ({})
    },
    pre: {
      type: String,
      default: ''
    }
  },
  computed: {
    label() {
      return this.col.label;
    },
    prop() {
      return this.col.prop;
    },
    child() {
      return this.col.child;
    },
    width() {
      return this.col.width;
    },
    editable() {
      return this.col.editable;
    },
    fixed() {
      return this.col.fixed;
    },
    type() {
      return this.col.type;
    }
  }
};
</script>

<style></style>
